import 'rgbaster'

export default {
  bind: function (el, bindings, vnode) {
  },
  inserted: function(el, bindings) {
    let src = el.querySelector('img')
    let backgroundColor = '#2e3a3e'

    el.classList.add('u-dominantColor')

    if(src) {
      global.RGBaster.colors(src, {
        exclude: [
          'rgb(255,255,255)',
          'rgb(0,0,0)',
        ],
        success: (payload) => {
          backgroundColor = payload.dominant
          el.style.backgroundColor = backgroundColor
        }
      })  
    } else {
      el.style.backgroundColor = backgroundColor
    }
  },
  update: function (el, bindings) {
  },
  unbind: function (el, bindings) {
  }
}


// WEBPACK FOOTER //
// ./src/plugins/dominant-color/directive.js